<template lang="pug">
    .post-preview
        .image
            figure
                img(v-if="image" :src="image.src" :title="post.title" )
        .meta
            small {{ topic }}
            small {{ createdAt }}
        .title
            h3(v-line-clamp:21="1") {{ post.title }}
        .bait(v-line-clamp:18="2")
            p.text(v-html="striptags(text)")
</template>

<script>
import striptags from 'striptags'
import { timestamp2date } from '@/filters'
import _ from 'lodash'

export default {
    name: 'PostOptionPreview',
    props: {
        post: {
            type: Object,
            required: true,
        }
    },
    computed: {
        topic() {
            return _.get(this.post, 'category.name')
        },
        image() {
            let image

            if (this.teaserSection) {
                const content = this.teaserSection.contents.find(content => content.key === 'image')
                if (content && content.images.length) image = content.images[0]
            }

            if (! image && this.sections.length) {
                this.sections.forEach(section => {
                    if (image) return

                    const content = section.contents.find(content => content.key === 'image')
                    if (content && content.images.length) image = content.images[0]
                })
            }

            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1.1111111111'
            const parameters = {
                // ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h } = parameters

            let width = 32
            let height = 32

            if (w && h) {
                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)
            } else if (! w && ! h) {
                fit += `&w=${width}&h=${height}`
            }

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
            }
        },
        createdAt() {
            return timestamp2date(this.post.created_at, this.$t('yyyy-MM-dd') + ' HH:mm')
        },
        text() {
            let content
            if (this.teaserSection) {
                content = this.teaserSection.contents.find(content => content.key === 'teaser')
            }

            if (! (content && content.text) && this.postSection) {
                content = this.postSection.contents.find(content => content.key === 'content')
            }

            // if (this.display === 'card') {
            //     text = truncate(content.text, 18, { byWords: true })
            // } else {
            //     text = truncate(content.text, 32, { byWords: true })
            // }

            return content.text
        },
        sections() {
            return this.post.sections
        },
        teaserSection() {
            return this.sections.find(section => section.key === 'category-page-teaser')
        },
        postSection() {
            return this.sections.find(section => section.key === 'post')
        },
    },
    methods: {
        striptags(html) {
            if (! html) return ''
            html = html.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />')
            return striptags(html, ['a', 'i', 'u', 'b', 'em', 'strong', 'span', 'br'])
        }
    }
}
</script>

<style lang="sass" scoped>
.post-preview
    display: grid
    grid-template-rows: auto auto auto
    grid-template-columns: 32px auto
    grid-column-gap: .4rem
    .meta
        color: $color-grey-text
        font-weight: initial
        display: flex
        align-items: baseline
        justify-content: space-between
        white-space: initial
        margin-top: 10px
        small
            line-height: 1
            display: block
    .title
        h3
            margin: 0
            line-height: 1
            max-width: 484px
            // white-space: nowrap
            // overflow: hidden
            // text-overflow: ellipsis
    .image
        grid-row: 1 / 3
        margin-top: .5rem
        margin-bottom: 5px
        // display: flex
        // align-items: center
        figure
            margin: 0
            background: $color-skeleton
            width: 32px
            height: 32px
            border-radius: 50%
            overflow: hidden
    .bait
        color: $--color-text-regular
        font-weight: initial
        width: 522px
        margin-bottom: 10px
        min-height: 18px
        word-break: normal !important
        grid-row: 3
        grid-column: 1 / 3
        br + br
            display: none
        ::v-deep p
            white-space: initial
            margin: 0
            line-height: 1.3
</style>
